import { toast } from 'react-toastify';
import parse from 'html-react-parser';

export const toastSuccess = (text, options = { autoClose: true }, isHtml) =>
  toast.success(isHtml ? parse(text) : text, options);
export const toastError = (text, options = { autoClose: false }, isHtml) =>
	toast.error(isHtml ? parse(text) : text, options);
export const toastWarning = (text, options = { autoClose: false }, isHtml) =>
	toast.warning(isHtml ? parse(text) : text, options);

